import { NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { Tag } from "@src/app/models/interfaces/tag.interface";
import { PortadaService } from "@src/app/servicios/portada/portada.service";
import { firstValueFrom } from "rxjs";
import { TitleWrapperService } from "src/app/servicios/title-wrapper/title-wrapper.service";
import { KebabCasePipe } from "../../pipes/kebab-case.pipe";

@Component({
  selector: "app-home-nav-menu",
  templateUrl: "./home-nav-menu.component.html",
  styleUrls: ["./home-nav-menu.component.css"],
  imports: [RouterLink, KebabCasePipe, NgIf, NgFor],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeNavMenuComponent implements OnInit {
  @Input() resizable: boolean;
  @Input() configPrensa: any;
  tags: Tag[] = [];
  configBloque: any;
  showBloque: any;
  showRevista: boolean;
  textoRevista: string;
  showTienda: boolean;
  textoTienda: string;
  enlaceTienda: string;
  bannerTags: boolean;
  constructor(
    private readonly portadaService: PortadaService,
    private readonly titleWrapperService: TitleWrapperService,
    private readonly elementRef: ElementRef,
  ) {}

  ngOnInit(): void {
    if (!this.configPrensa) return;
    const selectorName = this.elementRef.nativeElement.tagName.toLowerCase();
    this.configBloque = this.configPrensa.general[selectorName];
    this.showBloque = this.configBloque.bloque_activo === "true";
    this.bannerTags = this.configBloque.banner_tags === "true";
    if (this.bannerTags) {
      /* creo que no se usa */
      if (this.portadaService.getTags()) {
        firstValueFrom(this.portadaService.getTags()).then((result) => {
          this.tags = result;
        });
      }
    }
    if (!this.showBloque) return;
    this.showRevista = this.configBloque.mostrar_revista === "true";
    this.textoRevista = this.configBloque.texto_revista;
    this.showTienda = this.configBloque.mostrar_tienda === "true";
    this.textoTienda = this.configBloque.texto_tienda;
    this.enlaceTienda = this.configBloque.urlTienda;
  }

  trackByTag(index: number, tag: any): string | number {
    return tag?.idVideo ?? index;
  }

  setDocTitle(title: string) {
    this.titleWrapperService.setTitle(title);
  }
}
